import React from "react";
import { RCCButton, RCCIcon } from "react-common-components";
import IComponentDropDown from "react-common-components/dist/components/DropDown/interface";
import DropdownWithBackground from "src/components/DropdownWithBackground";

const OptionsColumn: React.FC<Omit<IComponentDropDown,|"callerComponent">> = ({children,...props}) => (
	<DropdownWithBackground
		position="left"
		callerComponent={
			<RCCButton
				color="transparent"
				styleInline="padding: 2px;"
			>
				<RCCIcon name="dotsVertical" size={20} color="var(--grey)"/>
			</RCCButton>
		}
		{...props}
	>
		{children}
	</DropdownWithBackground>
);

export default OptionsColumn;
